module.exports = __webpack_public_path__ + "0195596ee5bd01a85b250c7e389f01af.png";